import { Typo3NavLink } from '@/types'
type SlugParam = { slug: string[]; lang: string }

export function getStaticParams(
  navigation: Typo3NavLink[],
  lang: string
): SlugParam[] {
  const params: SlugParam[] = []
  if (!navigation || navigation.length === 0) {
    return params
  }
  function traverse(item: Typo3NavLink) {
    const slug = item?.link?.split('/').filter(Boolean).slice(1) // Remove the locale and empty segments
    if (slug && slug.length > 0) {
      params.push({ slug, lang })
    }

    if (item.children && item.children.length > 0) {
      item.children.forEach((child) => traverse(child))
    }
  }

  navigation.forEach((item) => traverse(item))
  return params
}
